
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch, FaTrash } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';

const Addholiday = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        holidaydate: '',
        holidaycountry: 'in',
        holidaytext: '',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
     
    const [formData2, setForm2Data] = useState({
        selectedclient: '',
        selectedsubclient: '',
        task:'',
        minutes:'',
        billedminutes:'',
        budgethours:'',
        remainingbudgethours:'',
        count:'',
        fillingfor:'',
        remarks:''
      });
     
    useEffect(()=>{
        // _getproject();
        getholiday();
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
     };

    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log('form daat');
        let date = formatterhelper.dateformatter({date:formData.holidaydate})  
        // console.log(formData);
        let obj = {
            ...formData,
            holidaydate_temp:date
        }
        addholiday(obj);    
        // addproject({project:formData.projectname});
    };


    function addholiday(obj){
    //   console.log(obj);   
      let objstr = JSON.stringify(obj);
      timesheetService.addholiday(objstr).then((response)=>{ 
        // console.log("response");  
        // console.log(response);
        if(response.status == 200){
            toast.current.show({ severity: 'success', summary: 'Holiday', detail: 'Holiday Added successfully', life: 3000 });   
            setFormData({
                holidaydate: '',
                holidaycountry: 'in',
                holidaytext: '',
            });

            getholiday();
        }else{
            toast.current.show({ severity: 'error', summary: 'Holiday', detail: 'Holiday not Added', life: 3000 });    
    
        }
      }).catch((error)=>{
         console.log(error);
         toast.current.show({ severity: 'error', summary: 'Holiday', detail: 'Error', life: 3000 });
         setFormData({
            holidaydate: '',
            holidaycountry: 'in',
            holidaytext: '',
        });   
      });
    }

    function getholiday(){
        let emparr = [];
        timesheetService.getholiday().then((response)=>{
             if(response.status == 200){
                  console.log(response.data,'get holiday');
                  
                   
                   setDatacomp(response.data.data);
                   setloading(true);
                   setDatastate(true);
             }else{
                setDatacomp([]);
                setloading(true);
                setDatastate(true);
             }
        }).catch((error)=>{
            setDatacomp([]);
            setloading(true);
            setDatastate(true);
        }); 
    }

    function displayholiday(){
        let emparr = [];
        datacomp.forEach((value,index)=>{
            emparr.push(<tr>
                <td>{index + 1}</td>
                <td>{value.date}</td>
                <td>{value.country}</td>
                <td>{value.value}</td>
                <td><button className='btn btn-danger' onClick={() => deleteholiday(value.id)}><FaTrash/></button></td>
                
             </tr>);
        }); 
        return emparr;
    }

    

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
       if (formData.projectname == '') {
          newErrors.projectname = 'Project name is required';
          valid = false;
        }

        setErrors(newErrors);

       return valid; 
    }

    function addproject({project}){

        if(!validateForm()){
              return;
        }
        adminService.addproject({project:project}).then((response)=>{
        //    console.log('response'); 
        //    console.log(response); 
           if(response.status  == 200){
               toast.current.show({ severity: 'success', summary: 'Project', detail: 'Added successfully', life: 3000 });   
             
           }else{
               toast.current.show({ severity: 'error', summary: 'Project', detail: 'Not Added', life: 3000 });   
           }
           _getproject(); 
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Project', detail: 'Something went wrong', life: 3000 });   
        });
    } 

    function _getproject(){
        let emparr = [];
        setloading(false);

        adminService.getproject().then((response)=>{
        //    console.log('response'); 
        //    console.log(response.data.data); 
           response.data.data.forEach((value,index)=>{
            //  console.log(value.name);
             emparr.push(<tr><td>{value.id}</td><td>{value.name}</td></tr>);
           });
           
           setDatacomp(response.data.data);
           setloading(true);
           setDatastate(true);
        //    const [datacomp,setDatacomp] = useState([]); 
        }).catch((error)=>{
            setloading(true);
            setDatastate(true);
        });
    } 

    function deleteholiday(id){
        console.log(id);
        timesheetService.deleteholiday(id).then((response)=>{
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Holiday', detail: 'Holiday deleted successfully', life: 3000 });     
                getholiday();
            }else{
              toast.current.show({ severity: 'error', summary: 'Holiday', detail: 'Not deleted', life: 3000 });      

            } 
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Holiday', detail: 'Error', life: 3000 });       
        });
    }

    return (
        <>
             <Toast ref={toast} />
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-3">
                        <label className='pull-left'>Select Date</label>
                        <br/>
                        <Calendar name="holidaydate" onChange={(e) => handleChange(e)} className='calender-custom-style custom-width-style' />
                        {/* <input type='date' name='projectname' onChange={(e)=>handleChange(e)} className='form-control'/> */}
                        {errors.projectname && <span className='error'>{errors.projectname}</span>}
                    </div>
                    <div className="col-md-3">
                        <label className='pull-left'>select holidaycountry</label>
                        <br/>
                        <select className='form-control' name='holidaycountry' onChange={(e) => handleChange(e)}>
                             <option value="in">INDIA</option>
                             <option value="usa">USA</option>
                             <option value="uk">UK</option>
                             
                        </select>
                        {/* <input type='date' name='projectname' onChange={(e)=>handleChange(e)} className='form-control'/> */}
                        {errors.projectname && <span className='error'>{errors.projectname}</span>}
                    </div>
                    <div className="col-md-4">
                        <label className='pull-left'>Holiday name</label>
                        <br/>
                        <input type='text' name='holidaytext' onChange={(e)=>handleChange(e)} className='form-control'/>
                        {errors.projectname && <span className='error'>{errors.projectname}</span>}
                    </div>
                    <div className="col-md-2 col-sm-12">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style' />
                        </div>

                    </div>
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                <div className='row'>
                    <div className='col-md-12'>
                    {!isloaded ? loader.Loadermd() : dataavail ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">SR No</th>
                                <th scope="col">Date</th>
                                <th scope="col">country</th>
                                <th scope="col">holiday</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayholiday()}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Addholiday;
